import ribbon from '../title/ribbon.svg'
import Card from '../../components/card'
import Badge from '../../components/badge';

export default function Knowledge({content,setRoute}){
	const url = window.global_data?.knowledge?.url;
	const {title,description} = window.global_data?.wheel
	if(url){
		return(
			<div className="row g-0">
				<div className="col-xl-6 col-lg-8 mx-auto py-5 px-3">
					<Card>
						<div className="text-center" style={{marginBottom:48}}>
							<Badge>
								Žaidimas baigtas
							</Badge>
						</div>

						<div className="py-4">
							<h2 className='vpe-card-title'>{title}</h2>
							{description && (
								<div className='vpe-card-description' dangerouslySetInnerHTML={{__html:description}}></div>
							)}
						</div>
						<UrlButton />
						
				</Card>
				</div>
			</div>
		)
	}

	return(
		<div className="container py-4">
			<Back />
			<div className="knowledge-content py-5" dangerouslySetInnerHTML={{__html:content}}></div>
			<div style={{textAlign:'right'}}>
				<Back />
			</div>
		</div>
	)
	function Back(){
		const btn = {
			color:'#163C60',
			fontWeight:'600',
			display:'inline-flex',
			alignItems:'center',
			padding:'.5rem',
			border:'none',
			background:'transparent'
		}
		return(
			<button onClick={()=>{setRoute('title')}} style={btn}>
				<svg className="me-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.828 7.00066H16V9.00066H3.828L9.192 14.3647L7.778 15.7787L0 8.00066L7.778 0.222656L9.192 1.63666L3.828 7.00066Z" fill="currentColor"/>
				</svg>
				Grįžti
			</button>
		)
	}
}


function UrlButton() {
	const blockBtn = {
		display:'block',
		width:'100%',
		padding:'1rem'
	};
	let url = window.global_data.knowledge.url;
	let url_regex = new RegExp(/^https?:\/\//);

	if(!url_regex.test(url)){
		url = 'http://' + url;
	}
	return(
		<>
			<a href={url} target="_blank" rel="noopener noreferrer" style={blockBtn} className="btn btn-secondary mb-4">
				Sužinok
				<img src={ribbon} className="ms-2" alt="M" />
			</a>
			<button style={blockBtn} className="btn btn-outline-secondary" onClick={()=>{window.location.reload()}}>
				Iš naujo
				<svg className="ms-2" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M20.3444 21.0804C18.1669 22.9672 15.3812 24.004 12.5 24C5.8724 24 0.5 18.6276 0.5 12C0.5 5.3724 5.8724 0 12.5 0C19.1276 0 24.5 5.3724 24.5 12C24.5 14.5632 23.696 16.9392 22.328 18.888L18.5 12H22.1C22.0998 9.78744 21.3354 7.64287 19.936 5.92907C18.5366 4.21526 16.5882 3.03743 14.4204 2.59483C12.2526 2.15223 9.99839 2.47202 8.03921 3.50012C6.08003 4.52821 4.53611 6.20149 3.66863 8.23689C2.80115 10.2723 2.66337 12.5449 3.27859 14.6702C3.89381 16.7955 5.22427 18.643 7.0449 19.9003C8.86552 21.1575 11.0645 21.7473 13.27 21.5699C15.4754 21.3924 17.5518 20.4586 19.148 18.9264L20.3444 21.0804Z" fill="currentColor"/>
				</svg>

			</button>
		</>
	)
}